import React, { forwardRef } from 'react';
import { Stack as ChakraStack, StackProps } from '@chakra-ui/react';
interface Props extends StackProps {
  children?: React.ReactNode;
}
export const Stack = forwardRef<HTMLDivElement, Props>(
  (props, ref): JSX.Element => {
    return (
      <ChakraStack {...props} ref={ref}>
        {props.children}
      </ChakraStack>
    );
  }
);
export type { Props as StackProps };
